import * as React from "react";
import { Suspense } from "react";
import Employee from "../../stores/employee";
import { toast, jfetch } from "../../utils";
import * as moment from "moment";
import { normalizeApiResponse } from "../../libs/api_utils";

const EmployeeProfile = React.lazy(() => import("./EmployeeProfile"));

interface IInvitationStatus {
  accepted: boolean,
  acceptedAt?: string | null,
  sent: boolean,
  sentAt?: string | null
}

interface Props {
  employee: IJsonApiResponse<IEmployeeRecord>;
  invitationStatus: IInvitationStatus;
  lastActivity: IJsonApiResponse<UserTrackerRecord>;
}

interface State {
  employee?: Employee;
  reinviting: boolean;
  statusLoading:boolean;
  invitationStatus: IInvitationStatus;
  invitationStatusMsg: string;
  lastActivity: INormalizedObject | null
}

class EmployeeProfileContainer extends React.Component<Props, State> {

  state: Readonly<State> = {
    reinviting: false,
    statusLoading: false,
    invitationStatus: null,
    invitationStatusMsg: "",
    lastActivity: this.props.lastActivity.data
      ? normalizeApiResponse(this.props.lastActivity)
      : null
  };

  async componentDidMount() {
    const { Employee } = await import("../../stores/employee");
    const employee = new Employee(this.props.employee.data);
    this.setState({ employee, invitationStatus: this.props.invitationStatus }, this.setInvitationStatusMsg);
  }

  setInvitationStatusMsg = () => {
    const invitationStatus = this.state.invitationStatus;
    let msg = invitationStatus.sent
      ? (
        invitationStatus.sentAt
          ? `Invitation sent on ${moment(invitationStatus.sentAt).format("MMM Do YYYY")}`
          : `Invitation Sent`
      )
      : (
        (invitationStatus.accepted && invitationStatus.acceptedAt)
          ? `Joined on ${moment(invitationStatus.acceptedAt).format("MMM Do YYYY")}`
          : 'No active invitation'
      );
    this.setState({invitationStatusMsg: msg});
  }

  getLastActivityMsg = () => {
    const lastActivity = this.state.lastActivity;
    const lastActivityMoment = lastActivity ? moment(lastActivity.createdAt2) : null;
    const lastActivitySpan = lastActivityMoment
      ? <span title={lastActivityMoment.format("YYYY-MM-DD, h:mm:ss a")}>{lastActivityMoment.fromNow()}</span>
      : <span>Never</span>;
    return <span>Last active: {lastActivitySpan}</span>;
  }

  reinvite = () => {
    const { employee, invitationStatus } = this.state;

    if (!employee) {
      return;
    }

    this.setState({ reinviting: true });

    const onComplete = (succeded: boolean) => {
      this.setState({ reinviting: false });
      if (succeded) {
        invitationStatus.sent = true;
        invitationStatus.sentAt = moment().format();
        this.setState({ invitationStatus: invitationStatus }, this.setInvitationStatusMsg);
      }
    };

    employee
      .reinvite()
      .then(() => {
        onComplete(true);
        toast.success("User invite resent!");
      })
      .catch(() => {
        onComplete(false);
        toast.error("Failed to resend user invite!");
      });
  };

  toggleStatus = () => {
    const { employee } = this.state;
    if (!employee) {
      return;
    }
    this.setState({statusLoading:true})

    jfetch.get(`/employees/${employee.id}/toggle_status`)
      .then(() => {
        let new_emp = employee
        new_emp['isActive'] = !new_emp['isActive']
        this.setState({employee:new_emp, statusLoading:false})
      })
  }

  render() {
    const { employee, reinviting, invitationStatus, invitationStatusMsg } = this.state;
    if (!employee) {
      return null;
    }

    return (
      <Suspense fallback={null}>
        <EmployeeProfile
          employee={employee}
          reinvite={this.reinvite}
          toggleStatus={this.toggleStatus}
          statusLoading={this.state.statusLoading}
          reinviting={reinviting}
          invitationStatus={invitationStatus}
          invitationStatusMsg={invitationStatusMsg}
          lastActivityMsg={this.getLastActivityMsg()}
        />
      </Suspense>
    );
  }
}

export default EmployeeProfileContainer;



// WEBPACK FOOTER //
// ./app/javascript/components/employee/EmployeeProfileContainer.tsx